/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum PlaylistSource {
    NAVIDROME = 'navidrome',
    NAVIDROME_ALBUM = 'navidrome_album',
}
